// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3ZMlr","approved":"Status_approved__2cITp","rejected":"Status_rejected__1rnMy","expired":"Status_expired__2asZH","label":"Status_label__2URSL"};